import {useEffect, useRef} from 'react'
import {css} from '@emotion/react'
import {useAiContext} from './AiContext.mjs'
import {ErrorMessage, ResponseMessage} from './AiMessage.jsx'
import {UserMessage} from './UserMessage.jsx'

const cssScroll = css({
    height: '100%',
    backgroundColor: '#fff',
    overflow: 'auto',
})

const Scroll = props => {
    const ai = useAiContext()
    const refEl = useRef()
    const refAutoScroll = useRef(false)
    const refUserScroll = useRef(true)

    useEffect(
        () => {
            const ac = new AbortController

            refEl.current.addEventListener(
                'scroll',

                () => {
                    if (refUserScroll.current) {
                        const {
                            clientHeight: ch,
                            scrollHeight: sh,
                            scrollTop: st,
                        } = refEl.current

                        refAutoScroll.current = st === sh - ch
                    }

                    refUserScroll.current = true
                },

                {signal: ac.signal}
            )

            return () => ac.abort()
        },

        []
    )

    const isRunning = ai.getIsRunning()

    useEffect(
        () => {
            // Agent 的消息更新可能伴随着状态更新，
            // 把标记改变放至下一循环以避免自动滚动失效
            setTimeout(() => {
                refAutoScroll.current = isRunning
            })
        },

        [isRunning]
    )

    useEffect(
        () => {
            if (refAutoScroll.current) {
                refUserScroll.current = false
                refEl.current.scrollTop = Number.MAX_SAFE_INTEGER
            }
        },

        [ai.messages]
    )

    return (
        <div
            ref={refEl}
            css={cssScroll}
            {...props}
        >
        </div>
    )
}

const cssMessages = css({
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    padding: '28px 16px',
})

const cssMessagesCompact = css({
    gap: 12,
    padding: 12,
})

export const Messages = props => {
    const ai = useAiContext()

    const messages = ai.messages.map(message => {
        const Message = {
            assistant: ResponseMessage,
            error: ErrorMessage,
            misc: ResponseMessage,
            user: UserMessage,
        }[message.role]

        return (
            <Message
                key={message.id}
                message={message}
            />
        )
    })

    return (
        <Scroll {...props}>
            <div css={[cssMessages, ai.compactView && cssMessagesCompact]}>
                {messages}
            </div>
        </Scroll>
    )
}
